<template>
  <h3 class="pb5">Rapport Affichage Excel</h3>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "RapportAffichageExcel",
  components: {ButtonBar},
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      criteresRecherche: {}
    };
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Autres");
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      this.criteresRecherche.titre = "RapportAffichageExcel";
      this.criteresRecherche.nomRapport = "RapportAffichageExcel";
      this.$store.dispatch("rapports/obtenirRapportAction", this.criteresRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>